import RestAPI from 'src/common/RestApi'

export const organizationProfile = () => RestAPI.get('/alpha/organization/profile')
